import { Route, RouteProps, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

type OwnProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any;
  redirect?: string;
};

interface StateProps {
  isAuthorized: boolean;
}

type Props = RouteProps & StateProps & OwnProps;

const ProtectedRoute = ({
  isAuthorized, component: Component, redirect = '/auth/login', ...rest
}: Props) => (
  <Route {...rest} render={(props) => (isAuthorized ? <Component {...props} /> : <Redirect to={redirect} />)} />
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any) => ({
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  isAuthorized: state.auth.data && state.auth.data.loggedIn,
});

export default connect<StateProps>(mapStateToProps)(ProtectedRoute);
